import { useCallback, useState } from 'react';
import { UseDisclosureReturn } from './useDisclosure';

export interface UseAbortControllerProps {
    confirmText?: string;
    isLoading?: boolean;
    handlers: UseDisclosureReturn[1];
    callback?: () => void;
}
export interface UseAbortControllerReturn {
    abortController: AbortController;
    setAbortController: (controller: AbortController) => void;
    onClose: () => void;
}

const useAbortController = (props: UseAbortControllerProps): UseAbortControllerReturn => {
    const {
        confirmText = 'Are you sure you want to close this window and terminate the process?',
        isLoading = false,
        handlers,
        callback
    } = props;

    const [abortController, setAbortController] = useState<AbortController>(new AbortController());

    const onClose = useCallback(() => {
        if (isLoading) if (!confirm(confirmText)) return;
        if (abortController) abortController.abort();
        callback?.();
        handlers.close();
    }, [isLoading, handlers, abortController, callback]);

    return { abortController, setAbortController, onClose };
};

export default useAbortController;
